/* eslint-disable no-dupe-keys */
export default {
  header: {
    home: 'Accueil',
    history: 'Histoire',
    suppliers: 'Fournisseurs',
    shop: 'Produits',
    career: 'Carrière',
    contactUs: 'Contactez-nous',
    callUsToday: 'Appelez-nous aujourd\'hui',
    chatWithUs: 'Communiquer avec nous',
    signIn: 'Connexion',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher...',
    searchProducts: 'Rechercher des Produits',
    close: 'Fermer',
    greeting: 'Bonjour',
    logout: 'Déconnexion',
    myAccount: 'Mon Compte',
    noProductsFound: 'Aucun produit trouvé',
    tryAnotherSearch: 'Essayez de chercher avec d\'autres termes'
  },
  auth: {
    signIn: 'CONNEXION',
    signUp: 'INSCRIPTION',
    email: 'E-mail',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    dontHaveAccount: "Vous n'avez pas de compte?",
    signUpFree: "S'inscrire gratuitement",
    firstName: 'Prénom',
    lastName: 'Nom',
    confirmPassword: 'Confirmer le mot de passe',
    create: 'CRÉER',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    allFieldsRequired: 'Veuillez remplir tous les champs obligatoires',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    signupError: 'Erreur lors de la création du compte. Veuillez réessayer.',
    loading: 'Chargement...',
    signupSuccess: 'Compte créé avec succès! Bienvenue!',
    firstNamePlaceholder: 'Entrez votre prénom',
    lastNamePlaceholder: 'Entrez votre nom',
    emailPlaceholder: 'Entrez votre e-mail',
    usernamePlaceholder: 'Entrez votre nom d\'utilisateur',
    passwordPlaceholder: 'Entrez votre mot de passe',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    forgotPasswordTitle: 'MOT DE PASSE OUBLIÉ',
    forgotPasswordInstruction: 'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    sendResetLink: 'ENVOYER LE LIEN',
    backToLogin: 'Retour à la connexion',
    resetLinkSent: 'Le lien de réinitialisation a été envoyé à votre e-mail.',
    resetLinkError: 'Erreur lors de l\'envoi du lien. Veuillez réessayer.',
    emailRequired: 'L\'e-mail est requis',
    resetPasswordTitle: 'RÉINITIALISER LE MOT DE PASSE',
    newPassword: 'Nouveau mot de passe',
    resetPassword: 'RÉINITIALISER',
    passwordResetSuccess: 'Mot de passe réinitialisé avec succès. Redirection vers la connexion...',
    passwordResetError: 'Erreur lors de la réinitialisation. Veuillez réessayer.',
    fieldRequired: 'Ce champ est obligatoire',
    signup: 'INSCRIPTION',
    invalidCredentials: 'Identifiants invalides',
    loginError: 'Erreur de connexion. Veuillez réessayer.',
    noProjectsTitle: 'Accès Refusé',
    noProjectsMessage: 'Vous n\'avez aucun projet associé à votre compte et ne pouvez pas accéder au système.',
    noProjectsContact: 'Veuillez contacter l\'administrateur pour demander l\'accès à un projet.',
    understood: 'Compris',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    selectProject: 'Sélectionnez un Projet',
    project: 'Projet',
    selectProjectPlaceholder: 'Sélectionnez un projet',
    location: 'Succursale',
    selectLocationPlaceholder: 'Sélectionnez une succursale',
    confirm: 'CONFIRMER',
    close: 'FERMER',
    noProjectsFound: 'Aucun projet trouvé pour cet utilisateur.',
    loadingProjects: 'Chargement des projets...',
    projectLoadError: 'Erreur lors du chargement des projets. Veuillez réessayer.',
    locationLoadError: 'Erreur lors du chargement des succursales. Veuillez réessayer.',
    retry: 'Réessayer',
    selectLocation: 'Sélectionnez une Succursale',
    selectLocationToContinue: 'Veuillez sélectionner une succursale pour continuer.'
  },
  cart: {
    shoppingCart: 'PANIER',
    subtotal: 'SOUS-TOTAL',
    taxesAndShipping: 'Taxes et frais de livraison calculés à la caisse',
    checkout: 'VALIDER',
    orderSummary: 'RÉSUMÉ DE LA COMMANDE',
    shipping: 'Livraison',
    total: 'TOTAL',
    viewCart: 'VOIR LE PANIER',
    close: 'Fermer',
    decrease: 'Diminuer la quantité',
    increase: 'Augmenter la quantité',
    remove: 'Supprimer l\'article',
    addToCart: 'AJOUTER',
    addCart: 'AJOUTER',
    quantity: 'Quantité',
    productAdded: "Produit ajouté au panier avec succès !",
    emptyCart: "Votre panier est vide",
    freeShipping: "Livraison Gratuite"
  },
  shoppingCart: {
    title: 'PANIER',
    subtotal: 'SOUS-TOTAL',
    taxesAndShipping: 'Taxes et frais de livraison calculés à la caisse',
    checkout: 'PAYER',
    product: 'Produit',
    addNotes: 'Ajouter des notes',
    notesPlaceholder: 'Ajoutez vos notes ici...',
    quantity: 'Quantité',
    total: 'TOTAL',
    continueShopping: "CONTINUER VOS ACHATS"
  },
  categories: {
    shopByCategories: 'ACHETER PAR CATÉGORIES',
    title: 'CATÉGORIES',
    price: 'PRIX',
    brands: 'MARQUES',
    sortBy: {
      featured: 'Tri par Vedettes',
      priceLowHigh: 'Prix: Bas à Élevé',
      priceHighLow: 'Prix: Élevé à Bas',
      nameAZ: 'Nom: A à Z',
      nameZA: 'Nom: Z à A'
    },
    showing: 'Affichage de {count} résultats'
  },
  hero: {
    bestShop: 'Votre Meilleure Produits en Ligne',
    specialOffers: 'Offres Spéciales',
    newCollection: 'Nouvelle Collection',
    shopNow: 'Acheter Maintenant'
  },
  products: {
    newProducts: 'NOUVEAUX PRODUITS',
    outOfStock: 'Rupture de Stock',
    price: 'Prix',
    description: 'Description',
    noProductsFound: 'Aucun produit trouvé',
    priceOnRequest: 'Prix sur demande',
    priceToConsult: 'Prix sur demande'
  },
  productSearch: {
    title: 'Ajouter des Produits au Panier',
    searchPlaceholder: 'Rechercher des produits à ajouter au panier...',
    noResults: 'Aucun produit trouvé. Essayez une autre recherche.',
    addToCart: 'Ajouter'
  },
  common: {
    previous: 'Précédent',
    next: 'Suivant',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    update: 'Mettre à jour',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    back: 'Retour',
    saving: 'Enregistrement...',
    updating: 'Mise à jour...',
    deleting: 'Suppression...',
    retry: 'Réessayer',
    myAccount: 'Mon Compte'
  },
  checkout: {
    calculating: "Calcul en cours",
    processing: "Traitement en cours",
    errorCalculating: "Erreur lors du calcul des valeurs",
    errorProcessingOrder: "Erreur lors du traitement de la commande",
    emptyCart: "Votre panier est vide",
    continueShopping: "CONTINUER VOS ACHATS",
    completePurchase: "FINALISER LA COMMANDE",

    title: 'CONFIRMATION',
    poNumber: 'Numéro P.O.',
    poNumberPlaceholder: 'Entrez le numéro P.O...',
    location: 'Emplacement de Commande',
    selectLocation: 'Sélectionnez l\'emplacement',
    deliveryMethod: 'Méthode de Livraison',
    delivery: 'Livraison',
    pickup: 'Ramassage',
    pickupDisabledNoProject: 'Le ramassage nécessite un projet associé',
    pickupRequiresProject: 'Le ramassage n\'est disponible que pour les clients avec un projet associé',
    companyAddresses: 'Adresses de l\'Entreprise',
    selectCompanyAddress: 'Sélectionnez une adresse',
    useThisAddress: 'Utiliser cette adresse',
    personalDetails: 'Informations Personnelles',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Entrez votre prénom...',
    lastName: 'Nom',
    lastNamePlaceholder: 'Entrez votre nom...',
    email: 'E-mail',
    emailPlaceholder: 'Entrez votre e-mail...',
    phone: 'Téléphone',
    phonePlaceholder: 'Entrez votre numéro de téléphone...',

    shippingDetails: 'Détails de Livraison',
    address: 'Adresse Ligne 1',
    addressPlaceholder: 'Entrez votre adresse...',
    apartment: 'Appartement/Suite',
    apartmentPlaceholder: 'Numéro d\'appartement (optionnel)...',
    city: 'Ville',
    cityPlaceholder: 'Entrez votre ville...',
    state: 'Province',
    statePlaceholder: 'Sélectionnez votre province...',
    postalCode: 'Code Postal',
    postalCodePlaceholder: 'Entrez votre code postal...',
    country: 'Pays',
    countryPlaceholder: 'Sélectionnez votre pays...',
    selectCountry: 'Sélectionnez le pays',
    selectState: 'Sélectionnez l\'état',
    errorLoadingCountries: 'Erreur lors du chargement des pays',
    errorLoadingStates: 'Erreur lors du chargement des états',
    invalidDate: 'Date invalide. Veuillez sélectionner une date valide (à partir de demain)',
    landmark: 'Adresse Ligne 2',
    landmarkPlaceholder: 'Entrez des informations d\'adresse supplémentaires...',

    paymentDetails: 'Détails du Paiement',
    cardHolder: 'Nom sur la Carte',
    cardHolderPlaceholder: 'Nom complet sur la carte...',
    cardNumber: 'Numéro de Carte',
    cardNumberPlaceholder: 'Entrez le numéro de carte...',
    expiryDate: 'Date d\'Expiration',
    expiryDatePlaceholder: 'MM/AA',
    cvv: 'CVV',
    cvvPlaceholder: '123',

    summary: {
      title: "RÉSUMÉ DE LA COMMANDE",
      taxes: "TAXES",
      shipping: "LIVRAISON",
      total: "TOTAL",
      freeShipping: "Livraison Gratuite"
    },
    errorLoadingAddress: "Erreur lors du chargement de l'adresse par défaut",
    errorLoadingLocations: "Erreur lors du chargement des emplacements",
    selectLocation: "Sélectionner un emplacement",
    location: "Emplacement",
    pickupLocation: "Point de Retrait",
    changeLocation: "Changer d'emplacement",
    useThisLocation: "Utiliser cet emplacement",
    noLocationsFound: "Aucun emplacement trouvé",
    completePurchase: 'FINALISER LA COMMANDE',
    fieldRequired: 'Ce champ est obligatoire',
    changeAddress: 'Changer l\'adresse',
    selectAddress: 'Sélectionner l\'adresse de livraison',
    useThisAddress: 'Utiliser cette adresse',
    manageAddresses: 'Gérer les adresses',
    neighborhood: 'Quartier',
    neighborhoodPlaceholder: 'Entrez votre quartier',
    minOrderValueMessage: 'La valeur minimale de commande est de {value}. Veuillez ajouter plus d\'articles à votre panier.',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    firstNamePlaceholder: 'Entrez votre prénom',
    lastNamePlaceholder: 'Entrez votre nom',
    emailPlaceholder: 'Entrez votre e-mail',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    addressLine1: 'Adresse Ligne 1',
    addressLine1Placeholder: 'Entrez l\'adresse',
    addressLine2: 'Adresse Ligne 2',
    addressLine2Placeholder: 'Entrez des informations d\'adresse supplémentaires',
    city: 'Ville',
    cityPlaceholder: 'Entrez la ville',
    state: 'État',
    statePlaceholder: 'Entrez l\'état',
    postalCode: 'Code Postal',
    postalCodePlaceholder: 'Entrez le code postal',
    country: 'Pays',
    countryPlaceholder: 'Entrez le pays',
    contactOnSite: 'Contact sur Site',
    contactOnSitePlaceholder: 'Entrez le nom du contact',
    contactPhone: 'Téléphone de Contact',
    contactPhonePlaceholder: 'Entrez le téléphone du contact',
    deliveryDate: 'Date de Livraison',
    deliveryDatePlaceholder: 'Sélectionnez la date de livraison...',
    pickupDate: 'Date de Retrait',
    pickupDatePlaceholder: 'Sélectionnez la date de retrait...',
    specialInstructions: 'Instructions Spéciales de Livraison',
    specialInstructionsPlaceholder: 'Ex.: livraison à un quai, livraison à l\'arrière',
    specialInstructionsPickup: 'Instructions Spéciales de Ramassage',
    specialInstructionsPlaceholderPickup: 'Ex.: créneau de retrait, type de véhicule, quai...',
    shippingDetails: 'Détails de Livraison',
    confirmProject: {
      title: 'Confirmation de Projet',
      message: 'Vous finalisez la commande pour le projet:',
      confirm: 'Confirmer et Continuer',
      changeProject: 'Sélectionner un Autre Projet',
      applyChange: 'Appliquer le Changement',
      noProjectsFound: 'Aucun projet trouvé pour cet utilisateur.',
      loadingProjects: 'Chargement des projets...',
      loadError: 'Erreur lors du chargement des projets. Veuillez réessayer.',
      retry: 'Réessayer'
    },
    confirmLocation: {
      message: 'Et pour la succursale:',
      changeLocation: 'Sélectionner une Autre Succursale',
      applyChange: 'Appliquer le Changement',
      loadingLocations: 'Chargement des succursales...',
      loadError: 'Erreur lors du chargement des succursales. Veuillez réessayer.',
      retry: 'Réessayer',
      noLocationsFound: 'Aucune succursale trouvée.'
    }
  },
  thankYou: {
    title: 'MERCI POUR VOTRE COMMANDE!',
    orderNumber: 'Commande #',
    emailConfirmation: 'La demande a bien été envoyée au système Empire.',
    continueShopping: 'CONTINUER VOS ACHATS'
  },
  footer: {
    titles: {
      products: 'PRODUITS',
      contactUs: 'CONTACTEZ-NOUS'
    },
    navigation: {
      home: 'Accueil',
      history: 'Histoire',
      suppliers: 'Fournisseurs',
      career: 'Carrière',
      heating: 'Chauffage',
      tools: 'Outils'
    },
    contact: {
      email: 'info@empirecanada.ca',
      address: '2320, rue Cohen, Saint-Laurent, QC H4R 2N8'
    },
    allRightsReserved: 'Tous Droits Réservés'
  },
  contact: {
    title: 'Contactez-nous',
    info: {
      title: 'Informations de Contact',
      phone: '+1 (514) 123-4567',
      email: 'info@empirecanada.ca',
      address: '2320, rue Cohen, Saint-Laurent, QC H4R 2N8'
    },
    email: 'info@empirecanada.ca',
    form: {
      title: 'Envoyez-nous un Message',
      name: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      subject: 'Sujet',
      selectSubject: 'Sélectionnez un sujet',
      subjects: {
        general: 'Demande Générale',
        support: 'Support Technique',
        sales: 'Ventes',
        other: 'Autre',
        jobApplication: 'Candidature d\'emploi'
      },
      message: 'Message',
      submit: 'Envoyer le Message',
      resume: 'CV',
      chooseFile: 'Choisir un fichier',
      noFileChosen: 'Aucun fichier choisi',
      acceptedFormats: 'Formats acceptés : PDF, DOC, DOCX (max 5MB)',
      resumeRequired: 'Veuillez joindre votre CV',
      invalidFileType: 'Type de fichier invalide. Veuillez télécharger un document PDF ou Word.',
      fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de 5MB.',
      submitSuccess: 'Votre message a été envoyé avec succès!',
      submitError: 'Une erreur est survenue lors de l\'envoi de votre message. Veuillez réessayer.',
      jobApplicationMessage: 'Je souhaite postuler pour le poste'
    }
  },
  productDetails: {
    addToCart: 'AJOUTER AU PANIER',
    shopNow: 'ACHETER MAINTENANT',
    selectColor: 'Couleur',
    selectSize: 'Taille',
    selectWeight: "Sélectionner le Poids",
    selectUnit: 'Unité de Mesure',
    // eslint-disable-next-line no-dupe-keys
    description: 'DESCRIPTION',
    bestSellers: 'MEILLEURES VENTES',
    addCart: 'AJOUTER',
    productName: 'Nom du Produit',
    shippingInfo: 'Informations de livraison',
    freeShipping: 'Livraison gratuite pour les commandes de plus de 200,00 $',
    selectOptions: 'Veuillez sélectionner la couleur et la taille',
    noDescription: 'Aucune description technique disponible pour ce produit.',
    requiredField: 'Ce champ est obligatoire',
    selectRequiredCharacteristics: 'Veuillez sélectionner toutes les caractéristiques requises avant d\'ajouter au panier',
    stock: {
      title: 'Stock',
      loading: 'Chargement des informations de stock...',
      noLocations: 'Aucun emplacement disponible',
      noStock: 'PAS DE STOCK',
      quantityToConfirm: 'Quantité à confirmer',
      inventoryToConfirm: 'Inventaire à confirmer',
      unitsAvailable: '{count} unités disponibles',
      unitAvailable: '1 unité disponible',
      selectLocation: 'Sélectionnez un emplacement pour acheter',
      quantityExceeded: 'La quantité demandée ({requested}) dépasse le stock disponible ({available}) à l\'emplacement sélectionné.',
      location1: { title: 'Québec Les Saules, QC Allée 17.', subtitle: '80 articles disponibles en stock' },
      location2: { title: 'Québec Les Saules, QC Allée 17.', subtitle: '80 articles disponibles en stock' },
      location3: { title: 'Québec Les Saules, QC Allée 17.', subtitle: '80 articles disponibles en stock' }
    }
  },
  categoryPage: {
    filters: 'FILTRES',
    clearAll: 'Tout effacer',
    categories: 'CATÉGORIES',
    price: 'PRIX',
    brands: 'MARQUES',
    sortBy: {
      label: 'Trier par',
      featured: 'Trier par Popularité',
      priceLowHigh: 'Prix: Croissant',
      priceHighLow: 'Prix: Décroissant',
      nameAZ: 'Nom: A à Z',
      nameZA: 'Nom: Z à A'
    },
    showingResults: 'Affichage de {count} résultats',
    itemsCount: 'Affichage de {start} à {end} sur {total}',
    previous: 'Précédent',
    next: 'Suivant',
    addToCart: 'AJOUTER AU PANIER',
    outOfStock: 'Rupture de Stock',
    noResults: 'Aucun produit trouvé',
    searchCategories: 'Rechercher des catégories...',
    showOnlyCategoriesWithProducts: 'Afficher uniquement les catégories avec produits',
    noCategories: 'Aucune catégorie trouvée',
    branches: 'FILIALES',
    filterBy: 'FILTRER PAR',
    searchPlaceholderShort: 'Rechercher',
    noBranches: 'Aucune filiale disponible',
    noAdditionalFilters: 'Aucun filtre additionnel disponible',
    noBrandsFound: 'Aucune marque trouvée',
    keywords: 'Mots-clés',
    selectedFilters: 'Filtres sélectionnés',
    clearFilters: 'Tout effacer',
    removeFilter: 'Retirer le filtre {name}',
    dynamicFilters: {
      searchPlaceholder: 'Rechercher...',
      noResultsFound: 'Aucun résultat trouvé',
      noOptionsAvailable: 'Aucune option disponible',
      showMore: 'Afficher plus',
      showLess: 'Afficher moins'
    },
    onlyInStock: 'Seulement en stock',
    didYouMean: 'Vouliez-vous dire',
    noResultsDetailed: 'Recherche : 0 résultats trouvés pour "{terms}"',
    display: 'Affichage:',
    resultsCount: '{count} résultats'
  },
  career: {
    title: 'Opportunités de Carrière',
    whyJoin: {
      title: 'Pourquoi Nous Rejoindre ?',
      benefit1: 'Salaire et avantages compétitifs',
      benefit2: 'Opportunités de croissance et développement professionnel',
      benefit3: 'Environnement de travail dynamique et innovant',
      benefit4: 'Équilibre travail-vie personnelle et horaires flexibles'
    },
    openings: {
      title: 'Postes Disponibles',
      position1: {
        title: 'Développeur Logiciel',
        description: 'Rejoignez notre équipe de développement pour créer des solutions innovantes avec des technologies de pointe.'
      },
      position2: {
        title: 'Designer UX/UI',
        description: 'Aidez-nous à créer des expériences utilisateur belles et intuitives pour nos produits numériques.'
      },
      position3: {
        title: 'Chef de Produit',
        description: 'Dirigez la stratégie et le développement des produits pour offrir une valeur exceptionnelle à nos clients.'
      }
    },
    loading: 'Chargement...',
    fetchError: 'Erreur lors du chargement des carrières.',
    apply: 'Postuler'
  },
  myAccount: {
    title: 'Mon Compte',
    orders: 'Commandes',
    ordersDescription: 'Suivez vos commandes et consultez l\'historique des achats',
    viewOrders: 'Voir les Commandes',
    personalInfo: 'Informations Personnelles',
    personalInfoDescription: 'Gérez vos informations personnelles et coordonnées',
    editProfile: 'Modifier le Profil',
    addresses: 'Adresses',
    addressesDescription: 'Gérez vos adresses de livraison',
    manageAddresses: 'Gérer les Adresses',
    favorites: 'Favoris',
    favoritesDescription: 'Consultez votre liste de produits favoris',
    viewFavorites: 'Voir les Favoris',
    security: 'Sécurité',
    securityDescription: 'Changez votre mot de passe et gérez la sécurité du compte',
    managePassword: 'Changer le Mot de Passe',
    logout: 'Déconnexion',
    logoutDescription: 'Déconnectez-vous du système',
    signOut: 'Se Déconnecter',
    settings: 'Paramètres du Système',
    settingsDescription: 'Configurez les données financières, le contenu du site et les informations de l\'entreprise',
    manageSettings: 'Gérer les Paramètres',
  },
    systemSettings: {
      title: 'Paramètres du Système',
      financial: 'Paramètres Financiers',
      financialDescription: 'Gérez les données financières, les modes de paiement et les paramètres fiscaux',
      systemMessages: 'Messages Système',
      systemMessagesDescription: 'Gérer les messages personnalisés affichés sur le site (checkout, fiche produit)',
      manageSystemMessages: 'Gérer les Messages',
    manageFinancial: 'Gérer les paramètres financiers',
    content: 'Contenu du Site',
    contentDescription: 'Configurez les pages d\'histoire, fournisseurs et carrières de l\'entreprise',
    manageContent: 'Gérer le contenu',
    company: 'Informations de l\'Entreprise',
    companyDescription: 'Mettez à jour l\'email, l\'adresse et le téléphone de l\'entreprise',
    manageCompany: 'Gérer les données de l\'entreprise',
    users: 'Paramètres Utilisateurs',
    usersDescription: 'Gérez les utilisateurs du système, les profils et les permissions',
    manageUsers: 'Gérer les utilisateurs',
    home: 'Page d\'Accueil',
    orders: 'Rapport de Commandes',
    ordersDescription: 'Consultez et exportez des rapports détaillés de toutes les commandes',
    manageOrders: 'Gérer les rapports de commandes',

    // Paramètres de Catégories/Produits
    categoryProduct: 'Catégories et Produits',
    categoryProductDescription: 'Gérez la visibilité des catégories et des produits sur le site.',
    manageCategoryProduct: 'Gérer les Catégories et Produits',
    searchCategories: 'Rechercher des catégories...',
    exactSearchTip: 'Utilisez des guillemets ("") pour rechercher des catégories avec un nom exact',
    searchProducts: 'Rechercher des produits...',
    showDisabled: 'Afficher les désactivés',
    showOnlyWithProducts: 'Afficher uniquement les catégories avec produits',
    noCategories: 'Aucune catégorie trouvée',
    noProducts: 'Aucun produit trouvé dans cette catégorie',
    noDescription: 'Pas de description',
    enabled: 'Activé',
    disabled: 'Désactivé',
    showProducts: 'Voir les produits',
    hideProducts: 'Masquer les produits',
    product: 'Produit',
    sku: 'SKU',
    price: 'Prix',
    status: 'Statut',
    categoryEnabled: 'Catégorie activée avec succès',
    categoryDisabled: 'Catégorie désactivée avec succès',
    productEnabled: 'Produit activé avec succès',
    productDisabled: 'Produit désactivé avec succès',
    errorLoadingCategories: 'Erreur lors du chargement des catégories',
    errorUpdatingCategory: 'Erreur lors de la mise à jour de la catégorie',
    errorUpdatingProduct: 'Erreur lors de la mise à jour du produit',
    noProductsInCategory: 'Sans produits'
  },
  users: {
    searchPlaceholder: 'Rechercher par nom ou email...',
    allProfiles: 'Tous les Profils',
    admin: 'Administrateur',
    manager: 'Gestionnaire',
    user: 'Utilisateur',
    name: 'Nom',
    email: 'Email',
    profile: 'Profil',
    actions: 'Actions',
    noUsersFound: 'Aucun utilisateur trouvé',
    loadError: 'Erreur lors du chargement des utilisateurs',
    updateSuccess: 'Profil utilisateur mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour du profil utilisateur',
    editUser: 'Modifier l\'Utilisateur',
    addUser: 'Ajouter un Utilisateur',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    password: 'Mot de passe',
    firstNamePlaceholder: 'Entrez le prénom',
    lastNamePlaceholder: 'Entrez le nom de famille',
    emailPlaceholder: 'Entrez l\'adresse email',
    passwordPlaceholder: 'Entrez le mot de passe',
    changePassword: 'Changer le mot de passe',
    selectProfile: 'Sélectionnez le profil',
    fillAllFields: 'Veuillez remplir tous les champs obligatoires',
    createSuccess: 'Utilisateur créé avec succès',
    createError: 'Erreur lors de la création de l\'utilisateur',
    showing: 'Affichage',
    of: 'sur',
    items: 'éléments'
  },
  profile: {
    title: 'Modifier le Profil',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    firstNamePlaceholder: 'Entrez votre prénom',
    lastNamePlaceholder: 'Entrez votre nom',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    emailNotEditable: "L'e-mail ne peut pas être modifié",
    save: 'Enregistrer les Modifications',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    fieldRequired: 'Ce champ est obligatoire',
    requiredFieldsError: 'Veuillez remplir tous les champs obligatoires',
    updateError: 'Erreur lors de la mise à jour du profil. Veuillez réessayer.',
    updateSuccess: 'Profil mis à jour avec succès!'
  },

  ordersSettings: {
    title: 'Rapport de Commandes',
    filters: 'Filtres',
    dateRange: 'Période',
    product: 'Produit',
    productPlaceholder: 'Entrez le nom du produit...',
    city: 'Ville',
    cityPlaceholder: 'Entrez la ville...',
    projects: 'Projets',
    projectsPlaceholder: 'Sélectionnez les projets...',
    pickupLocation: 'Point de Retrait',
    pickupAt: 'Retrait à',
    noLocationSpecified: 'Aucun emplacement spécifié',
    contactOnSite: 'Contact sur Site',
    contactPhone: 'Téléphone de Contact',
    deliveryDate: 'Date de Livraison',
    deliveryDateTime: 'Date de Livraison',
    specialInstructions: 'Instructions Spéciales de Livraison',
    poNumber: 'Numéro de Bon de Commande',
    additionalInfo: 'Informations Supplémentaires',
    multiselect: {
      noResult: 'Aucun résultat trouvé',
      noOptions: 'Liste vide',
      selectLabel: 'Appuyez sur Entrée pour sélectionner',
      selectedLabel: 'Sélectionné',
      deselectLabel: 'Appuyez sur Entrée pour retirer',
      placeholder: 'Sélectionnez une option',
      loading: 'Chargement...',
      loadingMore: 'Chargement de plus...',
      searching: 'Recherche...',
      maxElements: 'Limite atteinte',
      maxElementsText: 'Limite de {max} éléments atteinte',
      noElements: 'Aucun élément trouvé',
    },
    applyFilters: 'Appliquer les Filtres',
    resetFilters: 'Réinitialiser les Filtres',
    exportToExcel: 'Exporter vers Excel',
    exporting: 'Exportation...',
    ordersList: 'Liste des Commandes',
    sortBy: 'Trier par',
    dateNewest: 'Date: Plus récente',
    dateOldest: 'Date: Plus ancienne',
    totalHighest: 'Montant: Plus élevé',
    totalLowest: 'Montant: Plus bas',
    orderNumber: 'Numéro de Commande',
    orderNumberSearch: 'Recherche par nº de commande',
    orderNumberPlaceholder: 'ex. 2025- ou numéro complet',
    printOrder: 'Imprimer',
    printOrderTitle: 'Ouvrir pour impression ou PDF',
    printPriceOnRequest: 'Sur demande',
    printDocumentTitle: 'Commande',
    printHeading: 'Récapitulatif de commande',
    printSummaryTitle: 'Résumé',
    printDeliverySection: 'Livraison et détails',
    printFooter: 'Empire Canada — Merci de votre confiance.',
    printPopupBlocked: 'Autorisez les fenêtres pop-up pour imprimer la commande.',
    printError: 'Impossible de charger la commande pour l\'impression.',
    pdfViewerTitle: 'Commande',
    downloadPdf: 'Télécharger le PDF',
    printPdf: 'Imprimer',
    closePdf: 'Fermer',
    loadingPdf: 'Chargement du PDF…',
    pdfLoadError: 'Impossible de générer le PDF de la commande.',
    customerEmail: 'Courriel du client',
    customerPhone: 'Téléphone du client',
    deliveryMethod: 'Mode de commande',
    deliveryMethodDelivery: 'Livraison',
    deliveryMethodPickup: 'Retrait',
    branch: 'Succursale',
    noBranch: 'Aucune succursale',
    neovationOrder: 'Réf. Neovation',
    clientId: 'ID client',
    productCode: 'Code produit',
    date: 'Date',
    project: 'Projet',
    total: 'Total',
    status: 'Statut',
    actions: 'Actions',
    viewDetails: 'Voir Détails',
    noOrdersFound: 'Aucune commande trouvée',
    previous: 'Précédent',
    next: 'Suivant',
    noProject: 'Sans projet',
    orderDetails: 'Détails de la Commande',
    orderInfo: 'Informations de la Commande',
    shippingAddress: 'Adresse de Livraison',
    orderItems: 'Articles de la Commande',
    quantity: 'Quantité',
    unitPrice: 'Prix Unitaire',
    totalPrice: 'Prix Total',
    color: 'Couleur',
    size: 'Taille',
    weight: 'Poids',
    unit: 'Unité',
    subtotal: 'Sous-total',
    shippingCost: 'Frais de Livraison',
    taxAmount: 'Taxes',
    notes: 'Notes',
    status_pending: 'En Attente',
    status_processing: 'En Cours',
    status_completed: 'Terminée',
    status_cancelled: 'Annulée',
    updateStatus: 'Mettre à jour le statut',
    updateOrderStatus: 'Mettre à jour le statut de la commande',
    currentStatus: 'Statut actuel',
    newStatus: 'Nouveau statut',
    cancel: 'Annuler',
    updating: 'Mise à jour en cours',
    errorUpdatingStatus: 'Erreur lors de la mise à jour du statut de la commande',
    excel: {
      fileName: 'Commandes_Empire_Canada',
      orderNumber: 'Numéro de Commande',
      date: 'Date',
      project: 'Projet',
      status: 'Statut',
      product: 'Produit',
      quantity: 'Quantité',
      unitPrice: 'Prix Unitaire',
      totalPrice: 'Prix Total',
      address: 'Adresse',
      number: 'Numéro',
      complement: 'Complément',
      neighborhood: 'Quartier',
      city: 'Ville',
      state: 'État/Province',
      postalCode: 'Code Postal',
      country: 'Pays',
      shippingCost: 'Frais de Livraison',
      taxAmount: 'Taxes',
      orderTotal: 'Total de la Commande',
      notes: 'Notes'
    }
  },
  orders: {
    title: 'Mes Commandes',
    orderNumber: 'Commande #{number}',
    noOrders: 'Vous n\'avez pas encore passé de commande',
    noOrdersForFilter: 'Aucune commande ne correspond à ce numéro.',
    clearOrderFilter: 'Effacer le filtre',
    startShopping: 'Commencer les Achats',
    fetchError: 'Erreur lors du chargement des commandes. Veuillez réessayer.',
    quantity: 'Quantité',
    status: {
      pending: 'En Attente',
      processing: 'En Cours',
      completed: 'Terminée',
      cancelled: 'Annulée'
    },
    shipping: 'Frais de livraison',
    taxes: 'Taxes',
    total: 'Total',
    notes: 'Notes de Commande',
    noNotes: 'Aucune note pour cette commande',
    shippingAddress: 'Adresse de Livraison',
    pickupLocation: 'Point de Retrait',
    pickupAt: 'Retrait à',
    noLocationSpecified: 'Aucun emplacement spécifié',
    noShippingAddress: 'Aucune adresse de livraison disponible',
    landmark: 'Point de repère',
    noPriceOrder: 'Commande sans prix',
    additionalInfo: 'Informations Supplémentaires',
    project: 'Projet',
    projectId: 'ID du Projet',
    noProject: 'Aucun projet associé',
    branch: 'Succursale',
    noBranch: 'Aucune succursale associée',
    contactOnSite: 'Contact sur Site',
    contactPhone: 'Téléphone de Contact',
    deliveryDate: 'Date de Livraison',
    deliveryDateTime: 'Date de Livraison',
    specialInstructions: 'Instructions Spéciales de Livraison',
    poNumber: 'Numéro de Bon de Commande'
  },
  security: {
    title: 'Sécurité',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    updatePassword: 'Mettre à jour le mot de passe',
    passwordUpdated: 'Mot de passe mis à jour avec succès',
    currentPasswordIncorrect: 'Mot de passe actuel incorrect',
    updateError: 'Erreur lors de la mise à jour du mot de passe',
    allFieldsRequired: 'Tous les champs sont obligatoires',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères'
  },
  financial: {
    title: 'Paramètres Financiers',
    currencyCode: 'Code de la Devise',
    currencyCodePlaceholder: 'Ex: EUR, CAD, USD',
    currencySymbol: 'Symbole de la Devise',
    currencySymbolPlaceholder: 'Ex: €, $, £',
    taxRate: 'Taux de Taxe',
    taxRatePlaceholder: 'Entrez le taux de taxe en %',
    discountPercentage: 'Pourcentage de Remise',
    discountPercentagePlaceholder: 'Entrez le pourcentage de remise',
    minOrderValue: 'Montant Minimum de Commande',
    minOrderValuePlaceholder: 'Entrez le montant minimum de commande',
    freeShippingThreshold: 'Seuil de Livraison Gratuite',
    freeShippingThresholdPlaceholder: 'Entrez le montant minimum pour la livraison gratuite',
    requiredFieldsError: 'Veuillez remplir tous les champs obligatoires',
    updateSuccess: 'Paramètres financiers mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour des paramètres financiers',
    loadError: 'Erreur lors du chargement des paramètres financiers',
    fieldRequired: 'Ce champ est obligatoire',
    shippingCost: 'Frais de Livraison',
    shippingCostPlaceholder: 'Entrez les frais de livraison',
    enableAllFields: 'Activer Tous les Champs',
    enableAllFieldsDescription: 'Basculez pour activer ou désactiver tous les champs à la fois',
    noPermission: 'Vous n\'avez pas la permission de modifier ces paramètres',
    noPermissionToSave: 'Seuls les administrateurs peuvent enregistrer les modifications',
    readOnlyMode: 'Mode Lecture Seule',
    viewOnlyAccess: 'En tant que gestionnaire, vous pouvez uniquement consulter les paramètres actuels, mais vous ne pouvez pas les modifier.'
  },
  systemMessages: {
    title: 'Messages Système',
    loadError: 'Erreur lors du chargement des messages',
    updateSuccess: 'Messages mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour des messages',
    noPermission: 'Vous n\'avez pas la permission de modifier ces paramètres',
    readOnlyMode: 'Mode lecture seule',
    viewOnlyAccess: 'Vous pouvez uniquement visualiser ces paramètres',
    requiredFieldsError: 'Veuillez remplir tous les champs dans toutes les langues',
    french: 'Français',
    english: 'Anglais',
    portuguese: 'Portugais',
    checkoutPriceDisclaimer: {
      title: 'Avertissement de Prix (Checkout)',
      description: 'Message affiché dans la section Panier du checkout',
      placeholderFr: 'Les prix présentés sur le site peuvent varier. Le prix final sera validé dans votre confirmation de commande',
      placeholderEn: 'Prices shown on the site may vary. The final price will be validated in your order confirmation',
      placeholderPt: 'Os preços apresentados no site podem variar. O preço final será validado na sua confirmação de pedido'
    },
    productTransferInfo: {
      title: 'Information de Transfert (Fiche Produit)',
      description: 'Message affiché sur la fiche de détail du produit',
      placeholderFr: 'Pour un transfert d\'une autre succursale, prévoir un délai d\'environs 24 heures. Pour toute urgence, communiquer avec nous.',
      placeholderEn: 'For a transfer from another branch, allow approximately 24 hours. For any urgency, contact us.',
      placeholderPt: 'Para uma transferência de outra filial, prever um prazo de aproximadamente 24 horas. Para qualquer urgência, entre em contato conosco.'
    }
  },
  company: {
    name: 'Nom de l\'entreprise',
    namePlaceholder: 'Entrez le nom de l\'entreprise',
    email: 'E-mail',
    emailPlaceholder: 'Entrez l\'e-mail de l\'entreprise',
    phone: 'Téléphone',
    phonePlaceholder: 'Entrez le téléphone de l\'entreprise',
    website: 'Site Web',
    websitePlaceholder: 'Entrez le site web de l\'entreprise',
    websiteHint: 'Exemple: www.exemple.com ou https://exemple.com',
    address: 'Adresse',
    addressPlaceholder: 'Entrez l\'adresse de l\'entreprise',
    loadError: 'Erreur lors du chargement des données de l\'entreprise',
    updateSuccess: 'Informations de l\'entreprise mises à jour avec succès',
    updateError: 'Erreur lors de la mise à jour des informations de l\'entreprise',
    requiredFieldsError: 'Veuillez remplir tous les champs obligatoires',
    fieldRequired: 'Ce champ est obligatoire',
    saving: 'Enregistrement...',
    save: 'Enregistrer',
    contacts: {
      sectionTitle: 'Contacts de l\'entreprise',
      title: 'Gérer les contacts',
      manage: 'Ajouter',
      name: 'Nom',
      email: 'Courriel',
      phone: 'Téléphone',
      website: 'Site Web',
      address: 'Adresse',
      add: 'Ajouter un contact',
      edit: 'Modifier le contact',
      deleteConfirmation: 'Supprimer le Contact',
      deleteWarning: 'Cette action ne peut pas être annulée. Êtes-vous sûr de vouloir supprimer ce contact ?'
    }
  },
  content: {
    history: {
      title: 'Notre Histoire',
      description: 'Gérer le contenu historique de l\'entreprise, la chronologie et les étapes importantes',
      manage: 'Gérer l\'histoire',
      breadcrumb: 'Histoire',
      form: {
        title: 'Titre',
        titlePlaceholder: 'Entrez le titre de la section...',
        content: 'Contenu',
        contentPlaceholder: 'Entrez le contenu de la section...',
        year: 'Année',
        yearPlaceholder: 'Entrez l\'année...',
        add: 'AJOUTER UNE SECTION',
        edit: 'MODIFIER LA SECTION',
        cancel: 'Annuler'
      },
      actions: {
        hide: 'Masquer la section',
        show: 'Afficher la section',
        edit: 'Modifier la section',
        delete: 'Supprimer la section'
      },
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette section ?',
      deleteModal: {
        title: "Confirmer la suppression",
        message: "Êtes-vous sûr de vouloir supprimer cet élément de l'historique ? Cette action ne peut pas être annulée.",
        cancel: "Annuler",
        confirm: "Supprimer"
      },
      messages: {
        addSuccess: 'Section ajoutée avec succès',
        updateSuccess: 'Section mise à jour avec succès',
        deleteSuccess: 'Section supprimée avec succès',
        visibilitySuccess: 'Visibilité de la section mise à jour avec succès',
        loadError: 'Erreur lors du chargement des éléments historiques',
        addError: 'Erreur lors de l\'ajout de la section',
        updateError: 'Erreur lors de la mise à jour de la section',
        deleteError: 'Erreur lors de la suppression de la section',
        visibilityError: 'Erreur lors de la mise à jour de la visibilité de la section',
        deleteSuccess: "Élément supprimé avec succès",
        deleteError: "Erreur lors de la suppression de l'élément"
      },
      loading: 'Chargement...',
      fetchError: 'Erreur lors du chargement de l\'historique',
      foundation: {
        title: 'Fondation',
        text: 'Fondée en 1945, Empire Canada a débuté comme une petite Produits familiale de fournitures de plomberie à Montréal. La vision de nos fondateurs était de fournir des produits de qualité et un service exceptionnel aux entrepreneurs locaux et aux propriétaires.'
      },
      growth: {
        title: 'Croissance et Évolution',
        text: 'Grâce à des décennies de dévouement et d\'innovation, nous avons étendu nos opérations à travers le Canada, nous établissant comme un fournisseur leader dans l\'industrie de la plomberie et du chauffage.'
      },
      today: {
        title: 'Empire Aujourd\'hui',
        text: 'Aujourd\'hui, Empire Canada est un distributeur national avec plus de 50 emplacements, servant des milliers de professionnels tout en maintenant notre engagement envers la qualité et le service client.'
      }
    },
    suppliers: {
      title: "Fournisseurs",
      description: "Gérer le contenu des fournisseurs",
      manage: "Gérer les fournisseurs",
      breadcrumb: "Fournisseurs",
      form: {
        title: "Titre",
        titlePlaceholder: "Entrez le titre",
        content: "Contenu",
        contentPlaceholder: "Entrez le contenu",
        add: "AJOUTER UNE SECTION",
        edit: "Sauvegarder",
        cancel: "Annuler"
      },
      actions: {
        edit: "Modifier",
        delete: "Supprimer",
        show: "Afficher",
        hide: "Masquer"
      },
      deleteModal: {
        title: "Supprimer le fournisseur",
        message: "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.",
        confirm: "Supprimer",
        cancel: "Annuler"
      },
      messages: {
        addSuccess: "Fournisseur ajouté avec succès",
        updateSuccess: "Fournisseur mis à jour avec succès",
        deleteSuccess: "Fournisseur supprimé avec succès",
        visibilitySuccess: "Visibilité mise à jour avec succès",
        loadError: "Erreur lors du chargement des fournisseurs",
        addError: "Erreur lors de l'ajout du fournisseur",
        updateError: "Erreur lors de la mise à jour du fournisseur",
        deleteError: "Erreur lors de la suppression du fournisseur",
        visibilityError: "Erreur lors de la mise à jour de la visibilité"
      }
    },
    career: {
      title: 'Carrière',
      description: 'Gérer les offres d\'emploi, les exigences et le processus de candidature',
      manage: 'Gérer la carrière',
      breadcrumb: 'Carrière',
      form: {
        title: 'Poste',
        titlePlaceholder: 'Entrez le poste...',
        content: 'Description du poste',
        contentPlaceholder: 'Entrez la description du poste...',
        add: 'AJOUTER UN POSTE',
        edit: 'MODIFIER LE POSTE',
        cancel: 'Annuler'
      },
      actions: {
        hide: 'Masquer la section',
        show: 'Afficher la section',
        edit: 'Modifier la section',
        delete: 'Supprimer la section'
      },
      modal: {
        deleteTitle: 'Confirmer la suppression',
        deleteMessage: 'Êtes-vous sûr de vouloir supprimer cette section de carrière ? Cette action ne peut pas être annulée.',
        cancel: 'Annuler',
        confirm: 'Supprimer'
      },
      messages: {
        addSuccess: 'Section ajoutée avec succès',
        updateSuccess: 'Section mise à jour avec succès',
        deleteSuccess: 'Section supprimée avec succès',
        visibilitySuccess: 'Visibilité de la section mise à jour avec succès',
        loadError: 'Erreur lors du chargement des éléments de carrière',
        addError: 'Erreur lors de l\'ajout de la section',
        updateError: 'Erreur lors de la mise à jour de la section',
        deleteError: 'Erreur lors de la suppression de la section',
        visibilityError: 'Erreur lors de la mise à jour de la visibilité'
      }
    }
  },
  addresses: {
    title: 'Mes Adresses',
    address: 'Adresse',
    addNew: 'Ajouter une Nouvelle Adresse',
    street: 'Rue',
    streetPlaceholder: 'Entrez le nom de la rue',
    number: 'Numéro',
    numberPlaceholder: 'Entrez le numéro',
    complement: 'Complément',
    complementPlaceholder: 'Entrez le complément (optionnel)',
    neighborhood: 'Quartier',
    neighborhoodPlaceholder: 'Entrez le quartier',
    city: 'Ville',
    cityPlaceholder: 'Entrez la ville',
    state: 'État/Province',
    statePlaceholder: 'Entrez l\'état ou la province',
    postalCode: 'Code Postal',
    postalCodePlaceholder: 'Entrez le code postal',
    setAsDefault: 'Définir comme adresse par défaut',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette adresse?',
    saveSuccess: 'Adresse enregistrée avec succès',
    deleteSuccess: 'Adresse supprimée avec succès',
    deleteError: 'Erreur lors de la suppression de l\'adresse',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    default: 'Par défaut',
    requiredField: 'Ce champ est obligatoire',
    saveSuccess: 'Adresses enregistrées avec succès',
    saveError: 'Erreur lors de l\'enregistrement des adresses',
    loadError: 'Erreur lors du chargement des adresses',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette adresse?',
    deleteSuccess: 'Adresse supprimée avec succès',
    deleteError: 'Erreur lors de la suppression de l\'adresse',
    fillAllRequired: 'Veuillez remplir tous les champs obligatoires',
    deleteModal: {
      title: 'Supprimer l\'Adresse',
      message: 'Êtes-vous sûr de vouloir supprimer cette adresse ? Cette action ne peut pas être annulée.',
      cancel: 'Annuler',
      confirm: 'Supprimer'
    },
    noAddresses: "Vous n'avez pas d'adresses enregistrées"
  },
  suppliers: {
    pageTitle: 'Nos Fournisseurs',
    title: 'Nos Fournisseurs'
  },
  history: {
    pageTitle: 'Notre Histoire',
    title: 'Notre Histoire'
  },
  accessDenied: {
    title: 'Accès Refusé',
    message: 'Vous n\'avez pas la permission d\'accéder à cette page. Cette zone est réservée aux administrateurs et aux gestionnaires uniquement.',
    goHome: 'Aller à la Page d\'Accueil',
    goToAccount: 'Aller à Mon Compte'
  },
  pagination: {
    showing: 'Affichage',
    of: 'sur',
    prev: 'Précédent',
    next: 'Suivant',
    itemsPerPage: 'Éléments par page'
  },

  breadcrumb: {
    home: 'Accueil'
  },

  project: {
    selectProject: 'Sélectionnez un projet',
    changeConfirmation: {
      title: 'Changer de Projet',
      message: 'En changeant de projet, votre panier actuel sera vidé. Voulez-vous continuer?',
      confirm: 'Oui, changer de projet',
      cancel: 'Annuler',
      success: 'Projet changé avec succès!',
      error: 'Erreur lors du changement de projet. Veuillez réessayer.'
    }
  },
  location: {
    selectLocation: 'Sélectionnez une succursale',
    confirmChange: {
      title: 'Changer de Succursale',
      message: 'Vous changez pour la succursale:',
      confirm: 'Oui, changer de succursale',
      cancel: 'Annuler'
    }
  },

  settings: {
    home: {
      title: 'Page d\'Accueil',
      description: 'Gérez la bannière principale de la page d\'accueil, y compris les images, les titres et les couleurs.',
      manage: 'Gérer les Bannières'
    }
  },

  homeBanner: {
    title: 'Bannières de la Page d\'Accueil',
    addNew: 'Ajouter Nouveau',
    image: 'Image',
    title: 'Titre',
    subtitle: 'Sous-titre',
    status: 'Statut',
    position: 'Position',
    actions: 'Actions',
    active: 'Actif',
    inactive: 'Inactif',
    edit: 'Modifier',
    delete: 'Supprimer',
    noBanners: 'Aucune bannière trouvée',
    addBanner: 'Ajouter une Bannière',
    editBanner: 'Modifier la Bannière',
    titleColor: 'Couleur du Titre',
    subtitleColor: 'Couleur du Sous-titre',
    isActive: 'Bannière Active',
    chooseFile: 'Choisir un Fichier',
    noFileChosen: 'Aucun fichier choisi',
    imageRequirements: 'Recommandé: 1920x1080px, max 2Mo, formats: JPG, PNG, GIF, WEBP',
    invalidImageType: 'Type de fichier invalide. Veuillez utiliser JPG, PNG, GIF ou WEBP.',
    imageTooLarge: 'Image trop volumineuse. La taille maximale est de 2Mo.',
    confirmDelete: 'Confirmer la Suppression',
    deleteWarning: 'Êtes-vous sûr de vouloir supprimer cette bannière? Cette action ne peut pas être annulée.',
    fetchError: 'Erreur lors du chargement des bannières. Veuillez réessayer.',
    saveError: 'Erreur lors de l\'enregistrement de la bannière. Veuillez réessayer.',
    deleteError: 'Erreur lors de la suppression de la bannière. Veuillez réessayer.',
    createSuccess: 'Bannière créée avec succès!',
    updateSuccess: 'Bannière mise à jour avec succès!',
    deleteSuccess: 'Bannière supprimée avec succès!',
    titlePlaceholderPt: 'Entrez le titre en portugais',
    titlePlaceholderEn: 'Entrez le titre en anglais',
    titlePlaceholderFr: 'Entrez le titre en français',
    subtitlePlaceholderPt: 'Entrez le sous-titre en portugais',
    subtitlePlaceholderEn: 'Entrez le sous-titre en anglais',
    subtitlePlaceholderFr: 'Entrez le sous-titre en français',
    buttonText: 'Texte du Bouton',
    buttonTextPlaceholderPt: 'Entrez le texte du bouton en portugais',
    buttonTextPlaceholderEn: 'Entrez le texte du bouton en anglais',
    buttonTextPlaceholderFr: 'Entrez le texte du bouton en français',
    buttonTextHint: 'Laisser vide pour utiliser le texte par défaut "Shop Now"',
    buttonLink: 'Lien du Bouton',
    buttonLinkPlaceholder: 'Ex: /categories ou https://example.com',
    buttonLinkHint: 'Lien interne (ex: /categories) ou externe (ex: https://example.com). Laisser vide pour utiliser /categories'
  },

  homeTabs: {
    banner: 'Bannières',
    logo: 'Logo du Système',
    brands: 'Marques'
  },

  logo: {
    title: 'Logo du Système',
    addNew: 'Ajouter Nouveau',
    image: 'Image',
    name: 'Nom',
    description: 'Description',
    status: 'Statut',
    actions: 'Actions',
    active: 'Actif',
    inactive: 'Inactif',
    edit: 'Modifier',
    delete: 'Supprimer',
    noLogos: 'Aucun logo trouvé',
    addLogo: 'Ajouter un Logo',
    editLogo: 'Modifier le Logo',
    isActive: 'Logo Actif',
    chooseFile: 'Choisir un Fichier',
    noFileChosen: 'Aucun fichier choisi',
    imageRequirements: 'Recommandé: PNG avec fond transparent, max 1Mo',
    invalidImageType: 'Type de fichier invalide. Veuillez utiliser PNG ou SVG.',
    imageTooLarge: 'Image trop volumineuse. La taille maximale est de 1Mo.',
    confirmDelete: 'Confirmer la Suppression',
    deleteWarning: 'Êtes-vous sûr de vouloir supprimer ce logo? Cette action ne peut pas être annulée.',
    cannotDeleteActive: 'Impossible de supprimer le logo actif. Veuillez activer un autre logo d\'abord.',
    cannotDeleteOnly: 'Impossible de supprimer le seul logo du système.',
    fetchError: 'Erreur lors du chargement des logos. Veuillez réessayer.',
    saveError: 'Erreur lors de l\'enregistrement du logo. Veuillez réessayer.',
    deleteError: 'Erreur lors de la suppression du logo. Veuillez réessayer.',
    createSuccess: 'Logo créé avec succès!',
    updateSuccess: 'Logo mis à jour avec succès!',
    deleteSuccess: 'Logo supprimé avec succès!',
    activateSuccess: 'Logo activé avec succès!',
    activeInfo: 'Un seul logo peut être actif à la fois. Le logo actif sera affiché dans l\'en-tête et le pied de page du site.',
    firstLogoActive: 'C\'est le premier logo du système et il sera défini comme actif automatiquement.',
    cannotDeactivateOnly: 'Impossible de désactiver le seul logo actif. Au moins un logo doit être actif dans le système.'
  },

  brand: {
    title: 'Marques',
    addNew: 'Ajouter Nouvelle',
    image: 'Image',
    name: 'Nom',
    description: 'Description',
    status: 'Statut',
    position: 'Position',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Modifier',
    delete: 'Supprimer',
    noBrands: 'Aucune marque trouvée',
    addBrand: 'Ajouter une Marque',
    editBrand: 'Modifier la Marque',
    isActive: 'Marque Active',
    chooseFile: 'Choisir un Fichier',
    noFileChosen: 'Aucun fichier choisi',
    imageRequirements: 'Recommandé: PNG avec fond transparent, max 1Mo',
    invalidImageType: 'Type de fichier invalide. Veuillez utiliser PNG ou SVG.',
    imageTooLarge: 'Image trop volumineuse. La taille maximale est de 1Mo.',
    confirmDelete: 'Confirmer la Suppression',
    deleteWarning: 'Êtes-vous sûr de vouloir supprimer cette marque? Cette action ne peut pas être annulée.',
    fetchError: 'Erreur lors du chargement des marques. Veuillez réessayer.',
    saveError: 'Erreur lors de l\'enregistrement de la marque. Veuillez réessayer.',
    deleteError: 'Erreur lors de la suppression de la marque. Veuillez réessayer.',
    createSuccess: 'Marque créée avec succès!',
    updateSuccess: 'Marque mise à jour avec succès!',
    deleteSuccess: 'Marque supprimée avec succès!'
  }
}



























































